import {
  Container,
  Logo,
  MenuButton,
  SvgIcon,
  SidebarMenu,
  BackButton,
  Title,
} from "./styled";
import { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import logo from "../../assets/logo.png";
import SidebarContent from "../Sidebar/SidebarContent";
import { HeaderContext } from "../../containers/MainLayout";
import defaultAvatar from "../../assets/default_avatar.png";
import { ReactComponent as LogoutIcon } from "../../assets/logout.svg";
import { ReactComponent as ProfileIcon } from "../../assets/user.svg";
import { ReactComponent as SideBarIcon } from "../../assets/sidebar.svg";
import { logout } from "../../store/actions/auth.action";
import { useAppDispatch } from "../../store";

const HeaderComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { backAction, headerTitle } = useContext(HeaderContext);

  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    await dispatch(logout());
  };

  const menuItems = [
    {
      key: "profile",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "white",
            padding: "5px",
            fontWeight: '500',
          }}
        >
          <ProfileIcon width={20} height={20} />
          My Profile
        </span>
      ),
      onClick: () => navigate("/profile"),
    },
    {
      key: "logout",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "white",
            padding: "5px",
            fontWeight: '500',
          }}
        >
          <LogoutIcon width={20} height={20} />
          Logout
        </span>
      ),
      onClick: () => handleLogout(),
    },
  ];

  return (
    <>
      <Container>
        {/* Go Back Button */}
        {!!backAction ? (
          <BackButton
            onClick={() => {
              setIsOpen(false);
              backAction();
            }}
          >
            <SvgIcon
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </SvgIcon>
          </BackButton>
        ) : (
          <BackButton position="right">
            <Dropdown
              menu={{
                items: menuItems,
                style: {
                  background: "#1a1a1a",
                },
              }}
              placement="topRight"
              trigger={["click"]}
            >
              <img
                style={{ width: 30, height: 30, cursor: "pointer" }}
                src={defaultAvatar}
              />
            </Dropdown>
          </BackButton>
        )}

        {/* Logo */}
        {!!headerTitle ? (
          <Title>{headerTitle}</Title>
        ) : (
          <Logo
            src={logo}
            alt="Logo"
            onClick={() => {
              setIsOpen(false);
              navigate("/");
            }}
          />
        )}

        {/* Mobile Menu Icon */}
        <MenuButton
          position={!!backAction ? "right" : "left"}
          onClick={() => setIsOpen(!isOpen)}
        >
          <SideBarIcon width={22}  />
        </MenuButton>
      </Container>

      <SidebarMenu
        isOpen={isOpen}
        position={!!backAction ? "right" : "left"}
        className={isOpen ? "open" : ""}
        ref={menuRef}
      >
        <SidebarContent
          openSidebar={isOpen}
          closeAfterClicked
          setOpenSidebar={setIsOpen}
        />
      </SidebarMenu>
    </>
  );
};

export default HeaderComponent;
